import { ReviewCustomer } from './review_customer';
export class ReviewItem {
    constructor(review_item) {
        this.id                       = review_item.id;
        this.type                     = review_item.type;
        this.review_id                = review_item.review_id;
        this.user_name                = review_item.user_name;
        this.user_id                  = review_item.user_id;
        this.avatar                   = review_item.avatar;
        this.rating                   = review_item.rating;
        this.content                  = review_item.content;
        this.content_img1             = review_item.content_img1;
        this.content_img2             = review_item.content_img2;
        this.content_img3             = review_item.content_img3;
        this.review_reply_comment     = review_item.review_reply_comment;
        this.review_reply_update_time = review_item.review_reply_update_time;
        this.time_create              = review_item.time_create;
        this.time_update              = review_item.time_update;
        this.is_notification          = review_item.is_notification;
        this.created_at               = review_item.created_at;
        this.updated_at               = review_item.updated_at;
        this.status                   = review_item.status;
        this.customer                 = review_item.customer ? new ReviewCustomer(review_item.customer) : null;
    }
}